<template>
  <div>
    <!-- Hero Banner Start -->
    <hero-banner-one></hero-banner-one>
    <!-- Hero Banner End -->

    <!-- Feature Area Start -->
    <feature-area></feature-area>
    <!-- Feature Area End -->

    <!-- Popular Categories Start -->
    <category-area></category-area>
    <!-- Popular Categories End -->

    <!-- Product Banner Area Start -->
    <product-banner-area :ads="ads"></product-banner-area>
    <!-- Product Banner Area End -->

    <!-- Top Products Start -->
    <product-home-top-products></product-home-top-products>
    <!-- Top Products End -->

    <!-- Product Banner Two Start -->
    <product-banner-two :ads="ads"></product-banner-two>
    <!-- Product Banner Two End -->

    <!-- All Products Start -->
    <product-home-all-products></product-home-all-products>
    <!-- All Products End -->

    <!-- Feature Products Start -->
    <product-home-feature-products></product-home-feature-products>
    <!-- Feature Products End -->

    <!-- Moving Text Area Start -->
    <moving-text-area></moving-text-area>
    <!-- Moving Text Area End -->

    <!-- Product Banner Three Start -->
    <product-banner-area-three :ads="ads"></product-banner-area-three>
    <!-- Product Banner Three End -->

    <!-- Recommended Products Start -->
    <product-home-recommend-products></product-home-recommend-products>
    <!-- Recommended Products End -->

    <!-- Brand Area Start -->
    <brand-area></brand-area>
    <!-- Brand Area End -->

    <!-- CTA Area Start -->
    <cta-area></cta-area>
    <!-- CTA Area End -->
  </div>
</template>



<script>
import HeroBannerOne from '@/components/hero-banner/hero-banner-one.vue'
import FeatureArea from '@/components/feature/feature-area.vue'
import CategoryArea from '@/components/category/category-area.vue'
import ProductBannerArea from '@/components/product/banner/product-banner-area.vue'
import ProductBannerTwo from '@/components/product/banner/product-banner-two.vue'
import ProductBannerAreaThree from '@/components/product/banner/product-banner-area-three.vue'
import CtaArea from '@/components/cta/cta-area.vue'
import BrandArea from '@/components/brand/brand-area.vue'
import ProductHomeFeatureProducts from '@/components/product/home/feature-products.vue'
import ProductHomeTopProducts from '@/components/product/home/top-products.vue'
import { normalizeAdsList } from '@/utils/ad-media'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Home",
  components: {
    HeroBannerOne,
    ProductBannerArea,
    FeatureArea,
    CategoryArea,
    CtaArea,
    BrandArea,
    ProductHomeFeatureProducts,
    ProductBannerTwo,
    ProductBannerAreaThree,
    ProductHomeTopProducts
  },
  data() {
    return {
      ads: [], // Object to store ads grouped by ad type
      adsRefreshMs: 30000,
      adsRefreshIntervalId: null,
    }
  },
  computed: {
  },
  mounted() {
    this.fetchAds()
    this.adsRefreshIntervalId = setInterval(() => {
      this.fetchAds()
    }, this.adsRefreshMs)
  },
  beforeUnmount() {
    if (this.adsRefreshIntervalId) {
      clearInterval(this.adsRefreshIntervalId)
    }
  },
  methods: {
    async fetchAds() {
      try {
        const response = await this.$axios.get('/get-latest-ads')
        const raw = response.data.ads
        let list = []
        if (Array.isArray(raw)) {
          list = raw
        } else if (raw && typeof raw === 'object') {
          // API may return grouped ads like:
          // { "1": [..], "Top Left Advertisement": [..], ... }
          // Preserve group key as fallback add_type for each ad record.
          list = Object.entries(raw).flatMap(([groupKey, groupValue]) => {
            if (Array.isArray(groupValue)) {
              return groupValue.map((item) => ({
                ...item,
                add_type: item?.add_type ?? groupKey,
              }))
            }
            if (groupValue && typeof groupValue === 'object') {
              return [{
                ...groupValue,
                add_type: groupValue?.add_type ?? groupKey,
              }]
            }
            return []
          })
        }
        this.ads = normalizeAdsList(list)
      } catch (error) {
        this.ads = []
      }
    },

  },
}
</script>

<style scoped>
/* Add styles for Home page */
</style>